/**
 * Created by oleturvoll on 30/12/16.
 */

import { Person, AustralianAddress } from './';

export class AustralianCompany {

  private _name: string;
  private _description: string;
  private _abn: string;
  private _email: string;
  private _address: AustralianAddress;
  private _logo: string;
  private _phoneno: string;
  private _enabled: boolean;
  private _createdAt: Date;
  private _createdLocation: string;
  private _updatedLocation: string;
  private _updatedAt: Date;
  private _primaryContact: Person;
  private _secondaryContact: Person;


  constructor(name: string, abn: string, phoneno: string, primary: Person,
              secondary?: Person, address?: AustralianAddress) {

    this._name = name;
    this._abn = abn;
    this._phoneno = phoneno;
    this._primaryContact = primary;
    this._enabled = true;
    this._createdAt = new Date();
    this._createdLocation = 'TODO';

    if ( secondary != null) {
      this._secondaryContact = secondary;
    }
    if (address != null) {
      this._address = address;
    }
  }

  public getSecondaryContact(): Person {
    return this._secondaryContact;
  }

  public setSecondaryContact(value: Person) {
    this._secondaryContact = value;
  }
  public getPrimaryContact(): Person {
    return this._primaryContact;
  }

  public setPrimaryContact(value: Person) {
    this._primaryContact = value;
  }
  public getName(): string {
    return this._name;
  }

  public setName(value: string) {
    this._name = value;
  }

  public getDescription(): string {
    return this._description;
  }

  public setDescription(value: string) {
    this._description = value;
  }

  public getABN(): string {
    return this._abn;
  }

  public setABN(value: string) {
    this._abn = value;
  }

  public getEmail(): string {
    return this._email;
  }

  public setEmail(value: string) {
    this._email = value;
  }

  public getAddress(): AustralianAddress {
    return this._address;
  }

  public setAddress(value: AustralianAddress) {
    this._address = value;
  }

  public getLogo(): string {
    return this._logo;
  }

  public setLogo(value: string) {
    this._logo = value;
  }

  public getPhoneno(): string {
    return this._phoneno;
  }

  public setPhoneno(value: string) {
    this._phoneno = value;
  }

  public getEnabled(): boolean {
    return this._enabled;
  }

  public setEnabled(value: boolean) {
    this._enabled = value;
  }

  public getCreatedAt(): Date {
    return this._createdAt;
  }

  public setCreatedAt(value: Date) {
    this._createdAt = value;
  }

  public getCreatedLocation(): string {
    return this._createdLocation;
  }

  public setCreatedLocation(value: string) {
    this._createdLocation = value;
  }

  public getUpdatedLocation(): string {
    return this._updatedLocation;
  }

  public setUpdatedLocation(value: string) {
    this._updatedLocation = value;
  }

  public getUpdatedAt(): Date {
    return this._updatedAt;
  }

  public setUpdatedAt(value: Date) {
    this._updatedAt = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/australianCompany.ts